import { Component, ElementRef, ViewChild } from '@angular/core';
import { MegaMenuItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
/**
 * Application topbar — wires the sidebar menu button, right-panel button, mobile topbar
 * toggle, and search-input focus.
 *
 * `menuButton` and `mobileMenuButton` refs are consumed by `AppLayoutComponent` to exclude
 * them from outside-click detection on the sidebar and topbar overlays, respectively.
 */
export class AppTopbarComponent {
    
    @ViewChild('menuButton') menuButton!: ElementRef;

    @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

    @ViewChild('searchInput') searchInput!: ElementRef;
    
    constructor(public layoutService: LayoutService, public el: ElementRef) {}

    activeItem!: number;

    model: MegaMenuItem[] = [
    //    {
    //        label: 'UI KIT',
    //        items: [
    //            [
    //                {
    //                    label: 'UI KIT 1',
    //                    items: [
    //                        { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
    //                        { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
    //                        { label: 'Float Label', icon: 'pi pi-fw pi-bookmark', routerLink: ['/uikit/floatlabel'] },
    //                        { label: 'Button', icon: 'pi pi-fw pi-mobile', routerLink: ['/uikit/button'] },
    //                        { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] }
    //                    ]
    //                }
    //            ],
    //            [
    //                {
    //                    label: 'UI KIT 2',
    //                    items: [
    //                        { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
    //                        { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
    //                        { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
    //                        { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
    //                        { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] }
    //                    ]
    //                }
    //            ],
    //            [
    //                {
    //                    label: 'UI KIT 3',
    //                    items: [
    //                        { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
    //                        { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
    //                        { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
    //                        { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
    //                        { label: 'Misc', icon: 'pi pi-fw pi-circle-off', routerLink: ['/uikit/misc'] }
    //                    ]
    //                }
    //            ]
    //        ]
    //    },
    //    {
    //        label: 'UTILITIES',
    //        items: [
    //            [
    //                {
    //                    label: 'UTILITIES 1',
    //                    items: [
    //                        { label: 'Icons', icon: 'pi pi-fw pi-prime', routerLink: ['utilities/icons'] },
    //                        { label: 'PrimeFlex', icon: 'pi pi-fw pi-desktop', url: 'https://www.primefaces.org/primeflex/', target: '_blank' }
    //                    ]
    //                }
    //            ],

    //        ]
    //    }
    ];

    /** `true` when the mobile topbar menu overlay is open. */
    get mobileTopbarActive(): boolean {
        return this.layoutService.state.topbarMenuActive;
    }

    /** Toggles the main sidebar menu. */
    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    /** Opens the right side-panel. */
    onRightMenuButtonClick() {
        this.layoutService.openRightSidebar();
    }

    /** Toggles the mobile topbar menu overlay. */
    onMobileTopbarMenuButtonClick() {
        this.layoutService.onTopbarMenuToggle();
    }

    /** Defers focus to the search input by one event-loop tick via `setTimeout`. */
    focusSearchInput(){
       setTimeout(() => {
         this.searchInput.nativeElement.focus()
       }, 0);
    }
}
